import { render, staticRenderFns } from "./SessionResume.vue?vue&type=template&id=99bf5854&scoped=true&"
import script from "./SessionResume.vue?vue&type=script&lang=js&"
export * from "./SessionResume.vue?vue&type=script&lang=js&"
import style0 from "./SessionResume.vue?vue&type=style&index=0&id=99bf5854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bf5854",
  null
  
)

export default component.exports